// extracted by mini-css-extract-plugin
export default {"startRemoteSessionButton":"EQMivl_XFRFI4jAL0CJ9"};